import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

export const useCustomComponenteMakePrepaidHook = ({
  productsPrepaid,
  ActionMakePrepaid,
  ticketId,
  makePrepaid,
  listcommentsTikets,
  formData,
  onFormDataChange,
}) => {
  const { status } = makePrepaid || {};
  const { payload } = productsPrepaid || {};
  const { products } = payload || {};
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [isCompra, setIsCompra] = useState(formData?.is_paid !== 'false');

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      product_id: formData?.product_id || '',
      is_paid: formData?.is_paid || '',
      reason: formData?.reason || '',
    },
  });

  const onSubmit = (data) => {
    setLoading(true);
    const payload = {
      val: {
        ...data,
        is_paid: isCompra,
      },
      ticketId: ticketId,
    };
    ActionMakePrepaid(payload);
  };

  const handleSelectChange = (event) => {
    const productId = event.target.value;
    setValue('product_id', productId);
    if (typeof onFormDataChange === 'function') {
      onFormDataChange({ product_id: productId });
    }
  };

  const handlePaidChange = (event) => {
    const selectedValue = event.target.value;
    const value = selectedValue === 'true';
    setIsCompra(value);
    setValue('is_paid', selectedValue);
    if (typeof onFormDataChange === 'function') {
      onFormDataChange({ is_paid: selectedValue });
    }
  };

  const handleCommentChange = (event) => {
    const reason = event.target.value;
    setValue('reason', reason);
    if (typeof onFormDataChange === 'function') {
      onFormDataChange({ reason });
    }
  };

  useEffect(() => {
    if (status === 200) {
      setLoading(false);
      setStatusMessage('El registro fue exitoso');
      listcommentsTikets(ticketId);
    } else if (makePrepaid?.payload?.response?.status > 200) {
      setLoading(false);
      setStatusMessage(makePrepaid?.payload?.response?.data?.detail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, makePrepaid]);

  return {
    products,
    register,
    handleSubmit,
    handleSelectChange,
    handleCommentChange,
    onSubmit,
    loading,
    statusMessage,
    errors,
    setValue,
    isCompra,
    setIsCompra,
    handlePaidChange,
  };
};
